import { render } from "./GmxContainer.vue?vue&type=template&id=85b888b2&scoped=true"
import script from "./GmxContainer.vue?vue&type=script&lang=js"
export * from "./GmxContainer.vue?vue&type=script&lang=js"

import "./GmxContainer.vue?vue&type=style&index=0&id=85b888b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b888b2"]])

export default __exports__